import React, { useState, useEffect, useRef } from "react";
import { FaGithub, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { SiGmail } from "react-icons/si";

const Contact: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.2,
        rootMargin: "-50px"
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      id="contact" 
      className="min-h-screen flex flex-col items-center justify-center px-4 md:px-16 py-16"
    >
      <div 
        className={`transform transition-all duration-700 ${
          isVisible ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"
        }`}
      >
        {/* Terminal Icon */}
        <div className="flex justify-center mb-12">
          <div className="text-2xl text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.5)]">
            &gt;_
          </div>
        </div>

        {/* Main Text */}
        <h2 className="text-2xl md:text-3xl font-mono text-center mb-16 leading-relaxed drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]">
          Let's Build Something New<br />Now
        </h2>

        {/* Contact Text */}
        <div className="text-base font-mono text-center mb-6">
          Contact me:
        </div>

        {/* Social Links */}
        <div className="flex justify-center items-center gap-8">
          <a
            href="mailto:averofficial66@gmail.com"
            className="text-2xl transition-all duration-300 hover:scale-110 relative group"
            aria-label="Email"
          >
            <div className="relative">
              <SiGmail className="text-[#EA4335] drop-shadow-[0_0_8px_rgba(234,67,53,0.5)]" />
              <div className="absolute -right-1.5 -bottom-1.5 w-2 h-2 border-2 border-[#EA4335] border-t-transparent border-l-transparent rotate-45 animate-pulse" />
            </div>
          </a>

          <a
            href="https://www.linkedin.com/in/aver-godwin-a439a31b6/"
            className="text-2xl text-[#0A66C2] transition-all duration-300 hover:scale-110"
            aria-label="LinkedIn"
          >
            <FaLinkedin className="drop-shadow-[0_0_8px_rgba(10,102,194,0.5)]" />
          </a>

          <a
            href="https://github.com/Pjewels"
            className="text-2xl text-white transition-all duration-300 hover:scale-110"
            aria-label="GitHub"
          >
            <FaGithub className="drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]" />
          </a>

          <a
            href="https://x.com/pricelez_1"
            className="text-2xl text-white transition-all duration-300 hover:scale-110"
            aria-label="X (Twitter)"
          >
            <FaXTwitter className="drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact; 